/**
 * Pure helpers for rendering a Canvas SIS-import result. Shared by the Upload
 * detail page and the SIS Bundle detail page so both humanize Canvas's raw
 * count keys and processing-error payloads identically.
 */

/** "enrollments_deleted" → "Enrollments deleted". */
export function humanizeCountKey(k: string): string {
  const s = k.replace(/_/g, " ").trim();
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/**
 * Canvas processing-error/warning lines arrive as JSON-stringified objects like
 *   {"file":"…","message":"…","row":42}
 * Extract the human message with a `[file · row N]` prefix; fall back to the
 * raw line when it isn't the expected JSON shape.
 */
export function humanizeProcessingError(line: string): string {
  if (!line.trim().startsWith("{")) return line;
  try {
    const obj = JSON.parse(line) as {
      message?: string;
      file?: string;
      row?: number;
    };
    const parts: string[] = [];
    if (obj.file) parts.push(obj.file);
    if (obj.row !== undefined) parts.push(`row ${obj.row}`);
    const prefix = parts.length > 0 ? `[${parts.join(" · ")}] ` : "";
    return prefix + (obj.message ?? line);
  } catch {
    return line;
  }
}
